import React, { useState } from 'react'
import { Dropdown, DropdownMenu, DropdownMenuItem, DropdownButton } from 'live/components/forms/ui/dropdown/index'
import styled from 'styled-components'
import './custom-dropdown.scss'

export interface Option {
    id: number
    value: any // PERMITIR PASSAR HTML
}

interface IProps {
    disabled?: boolean
    options?: Option[]
    children?: any
    selected?: Option
    open: boolean
    clickItem: (item: Option) => void
    clickOutside?: () => void
}

const CustomDropdown = ({
    disabled = false,
    options = [],
    children,
    open = false,
    selected,
    clickOutside,
    clickItem
}: IProps) => {
    return (
        <Dropdown open={open} onClickOutside={clickOutside} disabled={disabled}>
            {children}

            <DropdownMenu open={open}>
                {options.map((option: Option) => {
                    const { id, value } = option

                    return (
                        <DropdownMenuItem key={id} onClick={() => clickItem(option)}>
                            <div className="custom-dropdown-menu-item">
                                <i className={`fas fa-check active ${selected?.id !== id && 'hide-check'}`}></i>

                                <span className={`${selected?.id === id && 'active'}`}>{value}</span>
                            </div>
                        </DropdownMenuItem>
                    )
                })}
            </DropdownMenu>
        </Dropdown>
    )
}

export default React.memo(CustomDropdown)
